import { CoreFetch, GetAdjustmentReportRequest, ProviderAdjustmentReportItem, ReportApi } from '@enter/core';
import { fetch } from './util';

export class DenialsService {
    /**
     * The adjustment report — every CARC the practice was hit with over a date range.
     *
     * This is the only endpoint that can currently say anything about denials. It takes `{start,
     * end}` and nothing else, so payer and provider scope are not expressible. It returns
     * `{group, reasonCode, count, amount}`, and neither number is what its name suggests: `count` is
     * remits and `amount` averages per remit (measured on production 2026-09-16). See `denial-rows.ts`
     * in core for the evidence and what the table does with it.
     */
    public fetchAdjustmentReport = async (
        request: GetAdjustmentReportRequest,
    ): Promise<ProviderAdjustmentReportItem[] | undefined> => {
        return fetch(request, async req => CoreFetch<ReportApi>(ReportApi).getAdjustmentReport(req));
    };
}
